export enum ResourceLoadingProgress {
  NOT_STARTED,
  IN_PROGRESS,
  FINISHED,
}
